import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { SCENARIO_API_URL } from "../../../config";
import { ModelCreateScenario } from "../types";

export interface ICreateScenarioMutation {
  data: ModelCreateScenario;
}

export const useModelCreateScenario = () => {
  return useMutation({
    mutationFn: (props: ICreateScenarioMutation) =>
      axios
        .post(
          `${SCENARIO_API_URL}/waves-scenario-manager-api/v1/scenarios/`,
          props.data,
          {}
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
